import React from 'react';

function ExtraSearch() {
	return (
		<div>
			<ol className="breadcrumb">
							<li className="breadcrumb-item"><a href="#/">Home</a></li>
							<li className="breadcrumb-item"><a href="#/">Pages</a></li>
							<li className="breadcrumb-item active"></li>
						</ol>
						
						
						<h1 className="page-header">Search Results <small className="ms-1">3 results found</small></h1>
						
						
						<div className="search-result">
							
							<div className="search-input">
								<form action="#" method="POST" name="search_form">
									<a href="#/" className="search-close" data-clear-form="#search">&times;</a>
									<input type="text" className="form-control form-control-lg" defaultValue="MacBook" />
								</form>
							</div>
							
							
							
							<div className="search-tab">
								<div className="search-tab-item"><a href="#/" className="search-tab-link active">Explore</a></div>
								<div className="search-tab-item"><a href="#/" className="search-tab-link">Accessories</a></div>
								<div className="search-tab-item"><a href="#/" className="search-tab-link">Support</a></div>
								<div className="search-tab-item"><a href="#/" className="search-tab-link">Store</a></div>
							</div>
							
							
							
							<div className="search-result">
								
								<div className="search-result-list">
									<div className="search-result-item">
										<div className="search-result-media">
											<a href="#/"><img src="/color-admin/admin/react/assets/img/search/macbook-pro.png" alt="" /></a>
										</div>
										<div className="search-result-content">
											<h4 className="fw-bold mt-2"><a href="#/" className="link-dark">MacBook</a></h4>
											<p>
												Our most powerful laptops, supercharged by the M5, M4 Pro, and M4 Max chips. Built for AI and Apple Intelligence. All day battery life.
											</p>
											<div className="d-flex flex-wrap gap-4">
												<a href="#/" className="fw-semibold">Learn more <i className="fa fa-chevron-right small"></i></a>
												<a href="#/" className="fw-semibold">MacBook Buy <i className="fa fa-chevron-right small"></i></a>
												<a href="#/" className="fw-semibold">MacBook Support <i className="fa fa-chevron-right small"></i></a>
											</div>
										</div>
									</div>
									<div className="search-result-item">
										<div className="search-result-media">
											<a href="#/"><img src="/color-admin/admin/react/assets/img/search/macbook-air.png" alt="" /></a>
										</div>
										<div className="search-result-content">
											<h4 className="fw-bold mt-2"><a href="#/" className="link-dark">MacBook Air</a></h4>
											<p>
												MacBook Air 13- and 15-inch laptops, now with M4 chip. Built for Apple Intelligence. All-day battery life and stunning Liquid Retina display.
											</p>
											<div className="d-flex flex-wrap gap-4">
												<a href="#/" className="fw-semibold">Learn more <i className="fa fa-chevron-right small"></i></a>
												<a href="#/" className="fw-semibold">MacBook Buy <i className="fa fa-chevron-right small"></i></a>
												<a href="#/" className="fw-semibold">MacBook Support <i className="fa fa-chevron-right small"></i></a>
											</div>
										</div>
									</div>
									<div className="search-result-item">
										<div className="search-result-content">
											<h4 className="fw-bold"><a href="#/" className="link-dark">MacBook - Apple</a></h4>
											<p>
												The incredibly thin and light MacBook features sixth-generation processors, improved graphics performance, and up to 10 hours of battery life....
											</p>
											<a href="#/" className="fw-semibold">https://www.apple.com/macbook/</a>
										</div>
									</div>
									<div className="search-result-item">
										<div className="search-result-content">
											<h4 className="fw-bold"><a href="#/" className="link-dark">MacBook Pro - macOS - Apple</a></h4>
											<p>
												MacBook Pro - macOS - Apple macOS. It’s why there’s nothing else like a Mac. macOS is the operating system that powers every Mac. It lets you do things you simply can’t with other computers. That’s...
											</p>
											<a href="#/" className="fw-semibold">https://www.apple.com/macbook-pro/macos/</a>
										</div>
									</div>
									<div className="search-result-item">
										<div className="search-result-content">
											<h4 className="fw-bold"><a href="#/" className="link-dark">MacBook Air - Design - Apple</a></h4>
											<p>
												MacBook Air is incredibly thin and light. But it’s also powerful, durable, and enjoyable to use. With enough battery life to get you through the day....
											</p>
											<a href="#/" className="fw-semibold">https://www.apple.com/macbook-air/design/</a>
										</div>
									</div>
									<div className="search-result-item">
										<div className="search-result-content">
											<h4 className="fw-bold"><a href="#/" className="link-dark">MacBook Air - Performance - Apple</a></h4>
											<p>
												MacBook Air is packed with powerful components that give you smoother graphics, faster storage, and all-around serious performance....
											</p>
											<a href="#/" className="fw-semibold">https://www.apple.com/macbook-air/performance/</a>
										</div>
									</div>
									<div className="search-result-item">
										<div className="search-result-content">
											<h4 className="fw-bold"><a href="#/" className="link-dark">MacBook Air - Technical Specifications - Apple</a></h4>
											<p>
												View the technical specifications for MacBook Air, see what comes in the box, explore configuration options, and get a list of accessories....
											</p>
											<a href="#/" className="fw-semibold">https://www.apple.com/macbook-air/specs/</a>
										</div>
									</div>
									<div className="search-result-item">
										<div className="search-result-content">
											<h4 className="fw-bold"><a href="#/" className="link-dark">MacBook - Design - Apple</a></h4>
											<p>
												MacBook is the thinnest and lightest Mac notebook ever — each detail refined for maximum efficiency and portability.
											</p>
											<a href="#/" className="fw-semibold">https://www.apple.com/macbook/design/</a>
										</div>
									</div>
									<div className="search-result-item">
										<div className="search-result-content">
											<h4 className="fw-bold"><a href="#/" className="link-dark">MacBook - Technical Specifications - Apple</a></h4>
											<p>
												View the technical specifications for MacBook. See what comes in the box and get a list of accessories.
											</p>
											<a href="#/" className="fw-semibold">https://www.apple.com/macbook/specs/</a>
										</div>
									</div>
									<div className="search-result-item">
										<div className="search-result-content">
											<h4 className="fw-bold"><a href="#/" className="link-dark">MacBook - Wireless - Apple</a></h4>
											<p>
												MacBook is designed to make the most of the wireless world. Share files, browse the web, print, and more — without being tied down to a cable....
											</p>
											<a href="#/" className="fw-semibold">https://www.apple.com/macbook/wireless/</a>
										</div>
									</div>
									<div className="search-result-item">
										<div className="search-result-content">
											<h4 className="fw-bold"><a href="#/" className="link-dark">MacBook - macOS - Apple</a></h4>
											<p>
												MacBook - macOS - Apple macOS. It’s why there’s nothing else like a Mac. macOS is the operating system that powers every Mac. It lets you do things you simply can’t with other computers. That’s...
											</p>
											<a href="#/" className="fw-semibold">https://www.apple.com/macbook/macos/</a>
										</div>
									</div>
								</div>
								
								
								
								<div className="text-center mt-4 mb-5">
									<div className="pagination justify-content-center">
										<div className="disabled page-item">
											<a href="#/" className="page-link">
												<span>«</span>
											</a>
										</div>
										<div className="active page-item"><a href="#/" className="page-link">1</a></div>
										<div className="page-item"><a href="#/" className="page-link">2</a></div>
										<div className="page-item"><a href="#/" className="page-link">3</a></div>
										<div className="page-item"><a href="#/" className="page-link">4</a></div>
										<div className="page-item"><a href="#/" className="page-link">5</a></div>
										<div className="page-item">
											<a href="#/" className="page-link">
												<span>»</span>
											</a>
										</div>
									</div>
								</div>
								
							</div>
							
						</div>
		</div>
	);
}

export default ExtraSearch;
